let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jaTPo")).then(() => parcelRequire('j6o0p'));